export default (number) => {
	number = number ? number : 0;
	return new Intl.NumberFormat('en-CA', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	}).format(number);
};
